/**
 * The composer toolbar's control styling — one size, one tint, one hover, so
 * the attachment clip, the mic and anything a caller drops into ChatInput's
 * `leadingActions` slot read as the same family of control rather than as
 * three separate decisions.
 *
 * ## Why it is its own module and not an export of `ChatInput`
 *
 * It started there (#1800). `LoopTrfButton` imports it to match the clip, and
 * `ChatInput` is mocked by the ChatPage suites — so importing the constant
 * from the component made the icon variant explode with *"No CONTROL_GHOST
 * export is defined on the mock"* the moment it rendered inside a suite that
 * stubs the composer. A value shared across a mock boundary has to live where
 * nothing mocks it. (The backend draws the same line for the same reason:
 * `helpers/auditActorRole.js` is its own module because the two places it
 * would otherwise belong are mocked by most of the suite.)
 *
 * Not a general-purpose class. It encodes the composer's own control tokens
 * (`--chat-control-size`, `--chat-control-radius`); a button elsewhere in the
 * app that borrows it will follow the composer when the composer changes.
 */
export const CONTROL_GHOST =
  'flex h-[var(--chat-control-size)] w-[var(--chat-control-size)] items-center justify-center rounded-[var(--chat-control-radius)] bg-transparent text-chat-text-muted transition-colors hover:bg-chat-surface-hover hover:text-chat-text disabled:opacity-50 disabled:cursor-not-allowed';
